export const TopbarMode = {
  Trending: 'trending',
  Positions: 'positions',
  Favorites: 'favorites',
  RecentSearch: 'recentSearch',
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TopbarMode = (typeof TopbarMode)[keyof typeof TopbarMode]

export const match = <T, P, F, RS>(
  value: TopbarMode,
  matchers: {
    [TopbarMode.Trending]: (value: typeof TopbarMode.Trending) => T
    [TopbarMode.Positions]: (value: typeof TopbarMode.Positions) => P
    [TopbarMode.Favorites]: (value: typeof TopbarMode.Favorites) => F
    [TopbarMode.RecentSearch]: (value: typeof TopbarMode.RecentSearch) => RS
  },
): T | P | F | RS => matchers[value](value as never)
